import Skeleton from '@mui/material/Skeleton';
import { PresetsItemsSectionBoxStyled } from 'pages/Presets/components/PresetsItemsSection/PresetsItemsSection.styled';
import {
  PresetItemDescriptionRowStyled,
  PresetItemRowStyled,
} from 'pages/Presets/components/PresetsItemsSectionRow/PresetsItemsSectionRow.styled';
import { Box } from 'shared/mui/Box';
import { Stack } from 'shared/mui/Stack/Stack';

export const PresetsEditItemsSkeleton: React.FC = () => {
  return (
    <Box sx={{ pt: '24px' }}>
      <PresetsItemsSectionBoxStyled>
        <PresetItemRowStyled>
          <Skeleton height={40} sx={{ marginBottom: '4px' }} variant="rounded" />
          <Skeleton height={40} sx={{ marginBottom: '4px' }} variant="rounded" />
          <Skeleton height={40} sx={{ marginBottom: '4px' }} variant="rounded" />
          <Skeleton height={28} sx={{ marginTop: '6px' }} variant="circular" width={28} />
          <PresetItemDescriptionRowStyled>
            <Skeleton height={40} variant="rounded" />
          </PresetItemDescriptionRowStyled>
        </PresetItemRowStyled>
        <Skeleton height={36} variant="rounded" width={191} />
      </PresetsItemsSectionBoxStyled>
      <Stack direction="row" gap={2} justifyContent="flex-end">
        <Skeleton height={36} variant="rounded" width={109} />
        <Skeleton height={36} variant="rounded" width={117} />
      </Stack>
    </Box>
  );
};
